import { getUserProfile } from 'utilities/AuthService';
import { UserOperation, UserProfile } from '../types/user';

function checkOperation(user: UserProfile, operation: UserOperation) {
  return user.Operations.indexOf(operation) > -1;
}

function useOperationAuthorizationChecks(operations: Array<UserOperation>): boolean {
  const user = getUserProfile();

  if (!user) return false;

  const checks = operations.map((operation) => checkOperation(user, operation));

  return checks.every((check) => check === true);
}

export default useOperationAuthorizationChecks;
